import { createSlice } from '@reduxjs/toolkit';

export const overviewPageInitialState = {
  overviewReportOption: '',
};

// Then, handle actions in your reducers:
const overviewPageSlice = createSlice({
  name: 'overviewPage',
  overviewPageInitialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    overviewPageSetSelectedReportOptionState: (state, { payload }) => {
      state.overviewReportOption = payload;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const { overviewPageSetSelectedReportOptionState } = overviewPageSlice.actions;

// The reducer
export const overviewPageReducer = overviewPageSlice.reducer;
